// Copyright (c) 2026 WiseTime. All rights reserved.

import * as Sentry from "@sentry/react"

Sentry.init({
  dsn: "https://471a47c35a3153bb027f4148ee18ae92@o372558.ingest.us.sentry.io/4510899153731584",
  environment: process.env.NODE_ENV,
  enabled: process.env.NODE_ENV === "production",
  initialScope: {
    tags: { app: "timeline-frontend" },
  },
  // Disabled for GDPR compliance
  // https://docs.sentry.io/platforms/javascript/guides/react/configuration/options/#sendDefaultPii
  sendDefaultPii: false,
})
